class ItensLaudoVistoriaCondicaoProdesp {
  GrupoVistoriaDescricao = '';
  ItemVistoriaDescricao = '';
  CondicaoDescricao = '';
  CondicaoTipo = '';
  DescricaoAdicional = '';
}

export class ItensLaudoVistoriaProcessoImagemOuVideoStorage {

  Id = '';
  ImagemLocalizacaoNome = '';
  DescricaoFormatada = '';
  ExisteCoordenadasBool: boolean;
  ImagemQualidade = 0;
  ImagemAltura = 0;
  ImagemLargura = 0;
  ImagemLocalizacaoTipo = '';
  TamanhoKbytes = 0;
  VideoBitRate = 0;
  VideoFrameRate = 0;
  VideoDuracaoString = '';
  VideoCodec = '';
  VideoKeyFrameIntervalo = 0;
  CaminhoAbsolutoArquivoProcessado = '';
  CaminhoAbsolutoArquivoOriginal = '';
  Informacao = '';
  Latitude = 0;
  Longitude = 0;
}

class ItensLaudoRetificacaoLista {
  DadosOriginais: boolean;
  KilometragemAlterada: boolean;
  BlankDianteiroAlterado: boolean;
  BlankTraseiroAlterado: boolean;
  BlankOpcionalAlterado: boolean;
  MunicipioDestinoAlterado: boolean;
  LaudoStatusAlterado: boolean;
  LacreAlterado: boolean;
  LaudoStatusString = '';
  RetificacaoNumero = '';
  MunicipioDescricao = '';
  Lacre = '';
  Kilometragem = 0;
  BlankDianteiro = '';
  BlankTraseiro = '';
  BlankOpcional = '';
  RetificadoDataHoraString = '';
}

class ItensFinalidadesVistoria {
  FinalidadeCodigo = 0;
  FinalidadeDescricao = '';
}

class ItensTiposCaracteristicas {
  TipoCaracteristicaCodigo = 0;
  TipoCaracteristicaNome = '';
}

class ItensHistoricoTentativaEmissao {
  RetornoCodigo = 0;
  NomeServidor = '';
  KM = 0;
  NumeroMotor = '';
  NumeroChassi = '';
  NomeAplicacao = '';
  RetornoDescricao = '';
  CodigoModalidadeEmissao = '';
  ProvedorConsulta = '';
  CodConsultaBin = 0;
  RetornoSeveridade = 0;
  DataHoraTentativa: Date;
}

export class VisualizarLaudoRespostaModel {
  CaminhoFotoVistoriador = '';
  CaminhoFotoVistoriadorInicio = '';
  NaoPossuiFotoVistoriadorInicio = '';
  CaminhoFotoVistoriadorTermino = '';
  NaoPossuiFotoVistoriadorTermino = '';
  NaoPossuiFotoVistoriador = '';
  EmpresaCnpj = '';
  EmpresaNome = '';
  TipoVistoria = '';
  SubTipoVistoria = '';
  LaudoNumero = '';
  DataHoraVistoria = '';
  ProprietarioNome = '';
  ProprietarioCpfCnpj = '';
  ProprietarioMunicipio = '';
  ProprietarioUf = '';
  ProprietarioEndereco = '';
  ProprietarioCep = '';
  ContratanteNome = '';
  ContratanteCpfCnpj = '';
  Placa = '';
  Renavam = '';
  MarcaModelo = '';
  TipoVeiculo = '';
  TipoCarroceria = '';
  Potencia = '';
  Cilindradas = '';
  Cor = '';
  Especie = '';
  Combustivel = '';
  CapacidadeCarga = '';
  Pbt = '';
  AnoFabricacao = '';
  AnoModelo = '';
  CapacidadePassageiros = '';
  Cmt = '';
  Motor = '';
  Chassi = '';
  Quilometragem = '';
  Lacre = '';
  LacreOpcional = '';
  BlankDianteiro = '';
  BlankTraseiro = '';
  BlankAdicional = '';
  MunicipioDestino = '';
  VistoriadorCpf = '';
  VistoriadorNome = '';
  Observacoes = '';
  DataVisualizacao = '';
  ProprietarioEmpresaAutorizadaTipo = '';
  ProprietarioPostoVistoriaTipo = '';
  CompradorNome = '';
  CompradorCpfCnpj = '';
  CompradorEmpresaAutorizadaTipo = '';
  PostoVistoriaEmpresaCnpj = '';
  PostoVistoriaEmpresaNome = '';
  PostoVistoriaEmpresaTipo = '';
  VistoriaModalidadeTipo = '';
  DispositivoFotoMotor = '';
  VistoriadorReconhecido = '';
  FaceAnaliseUsuarioNome = '';
  FaceAnaliseInicioDataHora = '';
  FaceAnaliseTerminoDataHora = '';
  FaceAnaliseObservacao = '';
  FaceAnaliseSituacao = '';
  VistoriadorValidado = '';
  NumeroBO = 0;
  OrgaoExpedidorBO = '';
  CategoriaVeiculo = '';
  LaudoEmitidoAutomaticamente: boolean;
  LaudoVistoriaProcessoImagemStorage: ItensLaudoVistoriaProcessoImagemOuVideoStorage[];
  LaudoVistoriaProcessoVideoStorage: ItensLaudoVistoriaProcessoImagemOuVideoStorage[];
  HistoricoTentativaEmissao: ItensHistoricoTentativaEmissao[];
  LaudoVistoriaCondicaoList: ItensLaudoVistoriaCondicaoProdesp[];
  LaudoRetificacaoLista: ItensLaudoRetificacaoLista[];
  LaudoVistoriaFinalidadeViewListInfo: ItensFinalidadesVistoria[];
  LaudoVistoriaTiposCaracteristicaViewListInfo: ItensTiposCaracteristicas[];
  NumeracaoMotorInacessivel = '';
  MotorAusente = '';
  NumeracaoVidros = '';
  FotoVistoriadorCadastradaTitulo = '';
  FotoVistoriadorInicioTitulo = '';
  FotoVistoriadorTerminoTitulo = '';
  MensagemErro = '';
  CodSetorDetranPE = '';
  CodVistoriaDetranPE = '';
  CondutorCPF = '';
  CondutorNome = '';
  CondutorDocumento = '';
  CondutorDocumentoUF = '';
  CsvNumero = '';
  EmpresaUf = '';
  InteressadoCodigo  = '';
  CondutorDocumentoOrgao = '';
  CondutorCelular = '';
  CondutorMunicipio = '';
  CondutorUF = '';
  CondutorCEP = '';
  CondutorLogradouro = '';
  CondutorNumero = '';
  CondutorComplemento = '';
  CondutorBairro = '';
  CondutorTelefone = '';
  LaudoEmitidoAutomaticamenteInformativo = '';
}
